import { LayoutModule } from '../../layout/modules';
import { ChatAssistantList } from './list';

import { useState } from 'react';
import { CHAT_ASSISTANT_NEW } from '../../../routes/paths';
import { ChatAssistantFilter } from '../../../shared/types/chat-assistant';
import { ChatAssistantFilters } from './filters';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { isAdminUser } from '../../../shared/utils/user';

export const ChatAssistants = () => {
    const [filters, setFilters] = useState<ChatAssistantFilter>();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    return (
        <>
            <LayoutModule
                title="Asistentes de chats"
                {...(isAdminUser(type)
                    ? { createPath: CHAT_ASSISTANT_NEW }
                    : {})}
            >
                <ChatAssistantFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <ChatAssistantList filters={filters} />
        </>
    );
};
